<div class="w-100 mt-5 pt-5"></div>
<div class="w-100 pt-3"></div>

<div class="container">
    <div class="row mt-5 mb-5">
        
        <!-- 🟢 SIDEBAR - PERFIL DE USUARIO -->
        <div class="col-sm-3 MenuDatos">
            <!-- Avatar del usuario -->
            <div class="profile-avatar">
                <img
                    *ngIf="datosUsuario.response.list[0].photo"
                    class="imagenPersona"
                    [src]="datosUsuario.response.list[0].photo"
                    [alt]="'Foto de ' + nombreUsuario()"
                />
                <img
                    *ngIf="!datosUsuario.response.list[0].photo"
                    src="/assets/image/portafolio/iconUser.png"
                    class="imagenPersona"
                    [alt]="'Avatar de ' + nombreUsuario()"
                />
            </div>

            <!-- Header del perfil -->
            <div class="profile-header">
                <div class="profile-title">Mi cuenta</div>
                <div class="profile-greeting">
                    Hola, <span class="user-name">{{this.nombreUsuario()}}</span>
                </div>
            </div>

            <!-- 🟢 Menú de navegación modernizado -->
            <nav class="Menu">
                <a
                    class="menuOption"
                    [routerLink]="['/mi-cuenta']"
                    routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}"
                >
                    <i class="fas fa-user-edit" aria-hidden="true"></i>
                    Mis datos personales
                </a>
                <a
                    class="menuOption"
                    [routerLink]="['/mi-cuenta/mis-pedidos']"
                    routerLinkActive="active"
                >
                    <i class="fas fa-shopping-bag" aria-hidden="true"></i>
                    Mis pedidos
                </a>
            </nav>
        </div>

        <!-- 🟢 CONTENIDO PRINCIPAL -->
        <div class="col-sm-9 contenido">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
